import React, { useEffect, useState } from 'react';
import { Row, Col, InputGroup, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService';
import CargandoSpinner from "../../Utils/CargandoSpinner";
import SeccionPageHeader from "../../Utils/SeccionPageHeader";
import { useAuth } from '../../../Auth/AuthContext';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';

export default function ExistenciasTotales() {
    const { token, user } = useAuth();
    const [cargando, setCargando] = useState(false);
    const [existencias, setExistencias] = useState([]);
    const [swalProps, setSwalProps] = useState({})
    const columns = [
        {
            name: 'Ayuda',
            selector: row => row.ayu_ayuda,
            sortable: true,
            width: '25%',
        },
        {
            name: 'Entidad',
            selector: row => row.ent_entidad,
            sortable: true,
            width: '11%',
        },
        {
            name: 'Cantidad actual',
            selector: row => row.ayu_saldo,
            sortable: true,
            width: '10%',
        }
    ];
    const exportarExistenciasExcel = () => {
        if (!existencias || existencias.length === 0) return;
        const worksheet = XLSX.utils.json_to_sheet(existencias);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ExistenciasBodega");
        XLSX.writeFile(workbook, "existencias_bodega.xlsx", { bookType: "xlsx" });
    };
    const ConsultarExistenciasBodega = async () => {
        const url = '/bodega/consultarexistenciastotales';
        const obj = {};
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            if(result.existencias){
                setExistencias(result.existencias);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    
    return (
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Existencias Bodega AHE"
                idCabezaFamilia="1"
                url="/bodega/ahe"
                nombreurl="AHE"
                nombreform="Consulta Existencias bodega AHE"
            />
            <CargandoSpinner Cargando={cargando} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary card-outline">
                                <div className="card-header">
                                    <h3 className="card-title">Consulta Existencias bodega AHE</h3>
                                </div>
                                <div className="card-body">
                                    <Row className="mb-3">
                                    <Col>
                                        <fieldset className="btn-group w-100 flex-wrap" aria-label="Opciones de consulta">
                                        <Button variant="primary" onClick={ConsultarExistenciasBodega} className="mb-2 me-2">
                                            Consultar existencias
                                        </Button>
                                        </fieldset>
                                    </Col>
                                    </Row>
                                </div>
                                <div className="card-body">
                                    <Button variant="success" onClick={exportarExistenciasExcel} className="mb-2 me-2">
                                        Exportar CSV
                                    </Button>
                                    <DataTable
                                        columns={columns}
                                        data={existencias}
                                        pagination
                                        highlightOnHover
                                        dense
                                        noDataComponent="No hay Existencias para mostrar"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SweetAlert2
                    {...swalProps}
                    didClose={() => setSwalProps({})}
                    onConfirm={() => {
                        if (swalProps.icon === 'success') {
                            setSwalProps({});
                            irAResultado();
                        } else {
                            setSwalProps({});
                        }
                    }}
                />
                <Tooltip id="tooltiparriba" place="right"/>  
            </section>
        </div>
    );

}